import { PricingType } from '@atlassian/cssxp-ccp-types';

export const isFreeOffering = (pricingType: string) => {
  return pricingType === PricingType.FREE || pricingType === PricingType.LIMITED_FREE;
};
